import React, { useEffect, useState } from "react";
import { Button, Form, Space, Row, Checkbox, Col, Typography, message } from "antd";
import { InputText, trans, InputDate } from "@comps/components"
import { Const } from "../../constants";
import { createSelectList } from '@comps/commonFunctions';
import { attendancePlannerPolicyDependencies } from "../policyDependencyConfig";
import PolicySelectWithActions from "./PolicySelectWithActions";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { policyTooltips } from "../../common/policyTooltips";

const CreateStepOne = (props) => {
  const langKey = Const["attendancePolicyPlanner"].lngKey
  const formName = "createAttendancePolicyPlanner";
  const fieldLabel = makeFieldLabel(policyTooltips.planner, { namespace: formName, label: (key) => trans(`${langKey}.${key}`) });
  //========================use states start========================
  const [policyOptions, setPolicyOptions] = useState({})
  const [form] = Form.useForm();
  const watchedValues = Form.useWatch([], form) || {};
  //=======================================
  useEffect(() => {
    setData();
    // eslint-disable-next-line
  }, [props]);

  //set props data
  //=================Submit First Step 1==============================================
  const setData = () => {
    if (!props.relatedData) {
      return;
    }

    const nextOptions = {};
    attendancePlannerPolicyDependencies.forEach((dependency) => {
      nextOptions[dependency.field] = createSelectList(props.relatedData[dependency.relatedListKey] || []);
    });
    setPolicyOptions(nextOptions);
  }

  //=====================On Submit Second Step===========================
  const onSubmitFirstStep = (data) => {
    const hasPolicyRule = attendancePlannerPolicyDependencies.some((dependency) => data[dependency.field]);
    if (!hasPolicyRule) {
      message.info("Add or select at least one attendance rule before continuing.");
      return;
    }

    props.response(data);
  }
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  return (
    <>
      <Form
        { ...formLayout }
        name={ formName }
        onFinish={ onSubmitFirstStep }
        initialValues={ props.initialValues ? props.initialValues : null }
        form={ form }
      >
        <div className="attendance-policy-guide__header">
          <Typography.Title level={ 4 }>Add attendance rules</Typography.Title>
          <Typography.Paragraph>
            Select the rules that should affect salary, leave quota, overtime payment, or CPL for this employee group.
          </Typography.Paragraph>
        </div>

        <Row gutter={ 30 }>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="name" rules={ rules.name } label={ fieldLabel("name") }
              className="da-mb-16"

            >
              <InputText placeholder="e.g. Head Office Attendance Policy" />
            </Form.Item>
          </Col>

          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="date" rules={ rules.date } label={ fieldLabel("date") }
              className="da-mb-16"

            >
              <InputDate />
            </Form.Item>
          </Col>

          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="for_all" rules={ rules.for_all } label={ fieldLabel("for_all") }
              className="da-mb-10"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          </Col>
          { attendancePlannerPolicyDependencies.map((dependency) => (
            <Col key={ dependency.key } lg={ 12 } sm={ 24 } xs={ 24 }>
              <PolicySelectWithActions
                name={ dependency.field }
                label={ fieldLabel(dependency.field) }
                placeholder={ `Select ${dependency.label.toLowerCase()} rule` }
                options={ policyOptions[dependency.field] || [] }
                buttonLabel={ `Add ${dependency.label} Rule` }
                selectedValue={ watchedValues[dependency.field] }
                onCreate={ () => props.onCreateDependency(dependency.key) }
                onEdit={ () => props.onEditDependency(dependency.key, watchedValues[dependency.field]) }
                onView={ () => props.onViewDependency(dependency.key, watchedValues[dependency.field]) }
              />
            </Col>
          )) }
        </Row>

        <Row justify="end" className="attendance-policy-planner-footer">
          <Space>
            <Button className="button-back" onClick={ props.onBack }>
              Back
            </Button>
            <Button className="button-next" type="primary" htmlType="submit">
              { watchedValues.for_all ? "Review policy" : "Choose employees" }
            </Button>
            {/* <CancelButton key="close_button" onClick={ () => props.onCancel(false) } /> */ }
          </Space>
        </Row>
      </Form>
    </>
  )
}
export default CreateStepOne
const rules = {
  date: [
    { required: true, message: 'Please select date' },
  ],
  name: [
    { required: true, message: 'Please enter name' },
  ],
};
const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
